import { Grid, GridRow } from '@bp/ui-components';
import { useAssignments } from 'components/Assignments/hooks/useAssignments';
import { UpdateSubmissionsMutation } from 'components/Submissions/hooks/useSubmissions';
import { useActivityProtocol } from 'hooks/matrix/useActivityProtocol';
import { useState } from 'react';
import { useMutation } from 'urql';
import { NotificationReason } from 'utils/matrixClient';
import { showSuccessUpdateToast, showUserDbErrorToast } from 'utils/toasts';
import { PublicSubmissionCard } from '../PublicSubmissionCard/PublicSubmissionCard';

type PublicSubmissionsTabProps = {
  courseUuid: string;
  assignmentUuid: string;
};

export const PublicSubmissionsTab = ({ courseUuid, assignmentUuid }: PublicSubmissionsTabProps) => {
  const { sendMessage } = useActivityProtocol();

  const [loading, setLoading] = useState<string | null>(null);

  const [, updateSubmission] = useMutation(UpdateSubmissionsMutation);

  const { assignments } = useAssignments({ courseUuid, assignmentUuid });

  const assignment = assignments.find((a) => a.uuid === assignmentUuid);
  if (!assignment) throw new Error('Assignment not found');

  const publicSubmissions = assignment.submissions.filter((s) => s.public);

  async function handleUpdateSubmission(uuid: string) {
    setLoading(uuid);
    const { error } = await updateSubmission({ where: { uuid }, update: { public: false } });
    if (error) {
      showUserDbErrorToast();
    } else {
      await sendMessage(uuid, NotificationReason.SubmissionDePublished, null, true);
      showSuccessUpdateToast();
    }
    setLoading(null);
  }

  return (
    <Grid>
      {publicSubmissions.map((submission) => {
        return (
          <GridRow key={submission.uuid}>
            <PublicSubmissionCard
              submissionUuid={submission.uuid}
              loading={!!loading && loading === submission.uuid}
              canRevoke
              onRevokePublicised={(uuid) => handleUpdateSubmission(uuid)}
            />
          </GridRow>
        );
      })}
    </Grid>
  );
};
